import React from 'react';
import '../Footer/Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                {/* Left Section: Contact Information */}
                <div className="footer-contact">
                    <h3>Visit Us</h3>
                    <p>Salaiban</p>
                    <p>Manjitsingh Sikh</p>
                    <p>Phone: 7588080115</p>
                    <p>Email: mankijit@gmail.com</p>
                    <p>Address: Salaiban, near Chalthana, Jalgaon Jamod Taluka, Buldana District, Maharashtra 443402</p>
                </div>

                {/* Center Section: Google Map */}
                <div className="footer-map">
                    <iframe
                        title="Google Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5318.257611913229!2d76.56770661942353!3d21.129116322072928!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd77b4a16180fc5%3A0x8fb52465d8a2400a!2sSalaiban%20Project!5e0!3m2!1sen!2sin!4v1732792603764!5m2!1sen!2sin"
                        width="300"
                        height="200"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                 </div>

                  {/* Right Section: Navbar Links */}
                  <div className="footer-navbar">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><a href="/home">Home</a></li>
                        <li><a href="/projects">Initiatives</a></li>
                        <li><a href="/gallery">Gallery</a></li>
                        <li><a href="/about">About Us</a></li>
                        <li><a href="/donate">Donate</a></li>
                    </ul>
                </div>

            </div>
        </footer>
    );
}

export default Footer;
